import { useEffect } from "react";

import { KeyBy } from "@m7-health/shared-utils";
import { keyBy } from "lodash";

import { useAppConfigQuery } from "#/features/User/queries";
import { IHealthSystem } from "@/api";
import { useDeepMemo } from "@/common/hooks";

import { TAppConfigState, useAppConfigDispatch } from "../../store";

import type { PayloadAction } from "@reduxjs/toolkit";

export type IHealthSystemState = {
  healthSystems: IHealthSystem[];
  healthSystemById: Partial<KeyBy<IHealthSystem, "id">>;
};

export const healthSystemInitialState: IHealthSystemState = {
  healthSystems: [],
  healthSystemById: {},
};

export const healthSystemActions = {
  setHealthSystems: (
    { healthSystem: state }: TAppConfigState,
    { payload }: PayloadAction<{ healthSystems: IHealthSystem[] }>,
  ) => {
    state.healthSystems = payload.healthSystems;
    state.healthSystemById = keyBy(payload.healthSystems, "id");
  },
};

export const useSynchHealthSystems = () => {
  const dispatch = useAppConfigDispatch();
  const appConfig = useAppConfigQuery();

  const healthSystems = useDeepMemo(
    () => appConfig.data?.healthSystems,
    [appConfig.data?.healthSystems],
  );

  useEffect(() => {
    if (!healthSystems?.length) return;

    dispatch.setHealthSystems({ healthSystems });
  }, [healthSystems, dispatch]);
};
